import React from "react";
import { STATUS_COLORS } from "@/lib/status";
import { useAuth } from "@/context/AuthContext";

export function StatusBadge({ code, className = "", testid }) {
  const { meta } = useAuth();
  const label = meta.statuses?.find((s) => s.code === code)?.label || code;
  return (
    <span
      data-testid={testid || `status-badge-${code}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${STATUS_COLORS[code] || "bg-slate-100 text-slate-700 border-slate-300"} ${className}`}
    >
      {label}
    </span>
  );
}
